export enum PersonalProfileRoutes {
  Profile = 'profile',
  Interests = 'interests',
  Notification = 'notification'
}
